import {useEffect} from "react";

import {fetchSingleRegionSimple} from "../../../search/actions/fetch_search_regions_action";
import {saveRecentRegionSearch} from "../../../search/utils/recent_filters_storage";
import {isValidSearchInputRegion} from "../utils/prices_search/is_valid_search_input_region";
import {consumePricesSearchMirrorMarker} from "../utils/prices_search/prices_recent_searches_storage";

/**
 * Landing side of mirroring a city picked in the prices search to the main search store. The pick only
 * leaves a sessionStorage marker, because a request started before `window.location.assign` would be cancelled. Here
 * the marker is consumed once, and when it is fresh and for this region, the region is fetched the way the main search
 * does for its popular regions (`SuggestedRegions`) and saved - only when it passes validation.
 */
export const useMirrorPricesRecentToMainSearch = (regionId: number | null | undefined): void => {
    useEffect(() => {
        if (!regionId || !consumePricesSearchMirrorMarker(regionId)) {
            return;
        }

        // Not cancelled on unmount: the marker is gone already and the save only touches localStorage.
        fetchSingleRegionSimple(regionId)
            .then((region: unknown) => {
                if (isValidSearchInputRegion(region) && region.id === regionId) {
                    saveRecentRegionSearch(region);
                }
            })
            // Best effort: without the region the main search simply does not get the entry.
            .catch(() => undefined);
    }, [regionId]);
};
import {useEffect} from "react";

import {fetchSingleRegionSimple} from "../../../search/actions/fetch_search_regions_action";
import {saveRecentRegionSearch} from "../../../search/utils/recent_filters_storage";
import {isValidSearchInputRegion} from "../utils/prices_search/is_valid_search_input_region";
import {consumePricesSearchMirrorMarker} from "../utils/prices_search/prices_recent_searches_storage";

/**
 * Landing side of mirroring a city picked in the prices search to the main search store. The pick only
 * leaves a sessionStorage marker, because a request started before `window.location.assign` would be cancelled. Here
 * the marker is consumed once, and when it is fresh and for this region, the region is fetched the way the main search
 * does for its popular regions (`SuggestedRegions`) and saved - only when it passes validation.
 */
export const useMirrorPricesRecentToMainSearch = (regionId: number | null | undefined): void => {
    useEffect(() => {
        if (!regionId || !consumePricesSearchMirrorMarker(regionId)) {
            return;
        }

        // Not cancelled on unmount: the marker is gone already and the save only touches localStorage.
        fetchSingleRegionSimple(regionId)
            .then((region: unknown) => {
                if (isValidSearchInputRegion(region) && region.id === regionId) {
                    saveRecentRegionSearch(region);
                }
            })
            // Best effort: without the region the main search simply does not get the entry.
            .catch(() => undefined);
    }, [regionId]);
};
